import {
    ExtendedConstructionNumber,
    GeneratedConstructionNumberStatus,
} from '../../api-utilities/api-utilities.types';
import { hasDatePassed } from '../../date';

const constructionNumberStatus = (
    constructionNumber: ExtendedConstructionNumber,
): GeneratedConstructionNumberStatus | undefined => {
    const { projectPhase, availabilityStatus, propertyType } = constructionNumber;
    const { status: propertyTypeStatus } = propertyType || {};
    const { status: apartmentBuildingStatus } = constructionNumber.apartmentBuilding || {};
    const { status: projectPhaseStatus, isRental } = constructionNumber.projectPhase || {};

    if (projectPhaseStatus === 'InPreparation') {
        return availabilityStatus === 'Reserved' ? 'Reserved' : 'InPreparation';
    }

    if (projectPhaseStatus === 'Sold') return 'UnderConstruction';

    switch (availabilityStatus) {
        case 'Reserved':
            if (
                projectPhaseStatus === 'OnSale' &&
                projectPhase?.allocationDate &&
                hasDatePassed(projectPhase.allocationDate)
            ) {
                return 'InOption';
            }
            return 'Reserved';
        case 'InOption':
        case 'Available':
            if (propertyTypeStatus === 'AssigningOn' || apartmentBuildingStatus === 'AssigningOn') {
                return 'AssigningOn';
            }
            return availabilityStatus;
        case 'Sold':
            return isRental ? 'Rented' : 'Sold';
    }

    return;
};

export { constructionNumberStatus };
